import { render } from "./Healing.vue?vue&type=template&id=3154dcec"
import script from "./Healing.vue?vue&type=script&lang=js"
export * from "./Healing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/healing/Healing.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3154dcec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3154dcec', __exports__)) {
    api.reload('3154dcec', __exports__)
  }
  
  module.hot.accept("./Healing.vue?vue&type=template&id=3154dcec", () => {
    api.rerender('3154dcec', render)
  })

}


export default __exports__